import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import {
  useAdminSettingsQuery,
  useNetworkDetailsMutation,
  useNetworkDetailsQuery,
} from "./store/ReduxApis";
import toast, { Toaster } from "react-hot-toast";
import Web3 from "web3";

function TokenRechargePage() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(adminAddr);
    toast("Address copied!");
  };

  const data = useAdminSettingsQuery();

  const [createPost, responseInfo] = useNetworkDetailsMutation();

  const [adminAddr, setAdminAddr] = useState("");
  const [adminBal, setAdminBal] = useState("");
  const [presaleAddr, setPresaleAddr] = useState("");
  const [contractAddr, setContractAddr] = useState("");
  const [amountVal, setAmountVal] = useState(0);
  const [userBalance, setUserBalance] = useState("0");
  const [block, setBlock] = useState("");
  const [loading, setLoading] = useState("");

  console.log(data);

  useEffect(() => {
    setAdminAddr(data?.data?.settings?.adminAccountDetails.adminAddress);
    // setAdminBal(data?.data?.settings?.adminAccountDetails.adminAddress)
    setPresaleAddr(data?.data?.settings?.smartContractAddress?.ico);
    setContractAddr(data?.data?.settings?.smartContractAddress?.elsyium);
    // setRpcurl(data?.data?.settings?.rpcUrl)
    // setBlock(data?.data?.settings?.blockExplorerUrls)
  }, [data]);

  useEffect(() => {
    if (presaleAddr && contractAddr) {
      getBalance();
    }
  }, [presaleAddr, contractAddr]); // ✅ Runs when these values are set

  const web3 = new Web3(process.env.REACT_APP_BSC_CHAIN_TESTNET_RPC_URL);
  const contractABI = JSON.parse(process.env.REACT_APP_CONTRACT_TESTNET_ABI);
  const stkTokenContract = new web3.eth.Contract(contractABI, contractAddr);

  const getBalance = async () => {
    try {
      // const web3 = new Web3(window.ethereum);
      // const contractABI = JSON.parse(process.env.REACT_APP_CONTRACT_TESTNET_ABI);

      if (!contractABI) {
        toast.error("Invalid contract ABI.");
        setAdminBal("0");
        return;
      }
      const tokenBalance = await stkTokenContract.methods
        .balanceOf(presaleAddr)
        .call();
      const formattedBalance = web3.utils.fromWei(tokenBalance, "gwei");

      setAdminBal(formattedBalance); // ✅ Update UI with balance
      console.log(
        "ConvertedBalance:",
        formattedBalance,
        "ActualBalance:",
        tokenBalance
      );
      // toast.success(`Balance: ${formattedBalance} STK`);
    } catch (error) {
      console.error("Balance Fetch Error:", error);
      toast("Failed to fetch balance.");
      setAdminBal("0");
    }
  };

  // ✅ Function to Switch Network to BNB
  const switchToBNBTestnet = async () => {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x61" }], // BNB Smart Chain  (Chain ID: 97)
      });
      toast.success("Switched to BNB Smart Chain !");
    } catch (switchError) {
      if (switchError.code === 4902) {
        // If network is not added, add it
        await window.ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: "0x61",
              chainName: "Binance Smart Chain",
              rpcUrls: [process.env.REACT_APP_BSC_CHAIN_RPC_URL],
              nativeCurrency: {
                name: "BNB",
                symbol: "BNB",
                decimals: 18,
              },
            },
          ],
        });
        toast.success("BNB Smart Chain added!");
      } else {
        toast.error("Failed to switch network.");
      }
    }
  };

  const rechargeToken = async (e) => {
    e.preventDefault();

    if (!amountVal || amountVal <= 0) {
      toast("Please enter a valid amount.");
      return;
    }

    if (!window.ethereum) {
      toast.error("Please install MetaMask!");
      return;
    }

    try {
      // const web3 = new Web3(window.ethereum);

      // ✅ Ensure Network is BNB Smart Chain Testnet
      const chainId = await web3.eth.getChainId();
      if (chainId !== 97) {
        await switchToBNBTestnet();
      }

      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const senderAddress = accounts[0];

      // ✅ Fetch token balance from contract
      const tokenBalanceWei = await stkTokenContract.methods
        .balanceOf(senderAddress)
        .call();
      const tokenBalanceEth = web3.utils.fromWei(tokenBalanceWei, "gwei"); // Convert to human-readable value

      // ✅ Update token balance state
      setUserBalance(tokenBalanceEth);

      // ✅ Check if user has enough token balance
      if (parseFloat(tokenBalanceEth) < parseFloat(amountVal)) {
        toast.error(
          "This account doesn't have enough tokens, please choose another account."
        );
        return;
      }

      // const gasLimit = 25000;
      // const amount = "0.5"; // ✅ Human-readable amount
      const amountInWei = web3.utils.toWei(amountVal, "gwei");
      const gasPrice = await web3.eth.getGasPrice();

      const sendTx = await stkTokenContract.methods
        .transfer(presaleAddr, amountInWei)
        .send({
          from: senderAddress,
          gas: 250000, // Adjusted gas limit
          gasPrice,
        });
      // .then((sendTx) => {
      //     console.log("Transaction Successful:", sendTx);
      //     toast.success("Transaction Successful!");

      //     setAmountVal(""); // ✅ Clears input after success
      //     getBalance();
      // })
      // .catch((error) => {
      //     console.error("Transaction Error:", error);
      //     toast.error(error.message || "Transaction failed.");
      // });

      console.log("Transaction Successful:", sendTx);
      toast.success("Transaction Successful!");
      setAmountVal("");
      getBalance(); // ✅ Refresh balance after transaction
    } catch (error) {
      // setAmountVal("")
      console.error("Transaction Error:", error);
      if (error.code === 4001) {
        toast.error("User cancelled the transaction.");
      } else {
        setAmountVal("");
        toast.error(error.message || "Transaction failed.");
      }
    }
  };

  // setTimeout(() => {
  //     getBalance();
  // }, 100000);

  // const newPost = {
  //     "chainid": chain,
  //     "network": networkName,
  //     "symbol": symbol,
  //     "decimals": decimal,
  //     "rpcUrl": rpcurl,
  //     "blockExplorerUrls": block
  // }

  // const details = (e) => {
  //     e.preventDefault()
  //     setLoading(true)
  //     createPost(newPost);
  // }

  // console.log(responseInfo)

  // useEffect(() => {
  //     if (responseInfo?.data?.status === "Success") {
  //         toast(responseInfo?.data?.message)
  //         setLoading(false)

  //     }
  // }, [responseInfo])

  return (
    <div>
      <Toaster />
      <div class="content-wrapper extra" style={{ marginTop: "2rem" }}>
        <div class="row">
          <div style={{ backgroundColor: "#141314" }} class="col-md-8 offset-2">
            <div class="card  card-primary" style={{ marginTop: "2rem" }}>
              <div class="card-header">
                <h3 class="card-title">Token Recharge Details</h3>
              </div>
              <form>
                <div className="form-header row align-items-center ">
                  <label
                    className="col-sm-4 control-label text-center"
                    for="inputEmail3"
                  >
                    QR Code
                  </label>
                  <div className="col-sm-4">
                    <img
                      src={`https://image-charts.com/chart?chs=250x250&cht=qr&chl=${presaleAddr}`}
                      width="250px"
                      height="250px"
                      alt="Wallet QR Code"
                    />
                  </div>

                  <div className="form-header row align-items-center mb-3">
                    <label
                      className="col-sm-4 control-label text-center"
                      for="inputEmail3"
                    >
                      Presale Address
                    </label>
                    <div className="col-sm-6 d-flex align-items-center justify-content-center">
                      <div className="col-sm-4 address-text justify-content-center">
                        <p className="header-color text-center balance-text">
                          {presaleAddr ? presaleAddr : ""}
                        </p>
                      </div>
                      <i
                        class="fa fa-copy"
                        onClick={handleCopy}
                        style={{ cursor: "pointer", marginLeft: "0.4rem" }}
                      ></i>
                    </div>
                  </div>

                  <div className="form-header row align-items-center mb-3">
                    <label
                      className="col-sm-4 control-label text-center"
                      for="inputEmail3"
                    >
                      Presale Balance
                    </label>
                    <div
                      className="col-sm-6 address-text justify-content-center"
                      style={{ marginLeft: "0rem" }}
                    >
                      <p className="header-color text-center balance-text">
                        {adminBal} $BotsCoin
                      </p>
                    </div>
                  </div>

                  <div className="form-header row align-items-center mb-3">
                    <label
                      className="col-sm-4 control-label text-center"
                      for="inputEmail3"
                    >
                      Presale Amount
                    </label>
                    <div
                      className="col-sm-6 justify-content-center"
                      style={{ marginLeft: "0rem" }}
                    >
                      <input
                        type="number"
                        class="txtPost"
                        placeholder="Amount"
                        name="amount"
                        value={amountVal}
                        onChange={(e) => setAmountVal(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  {/* <label className="col-sm-4 control-label" for="inputEmail3">Admin Address</label> */}
                  {/* <div className="d-flex">
                                                            <div className='col-12 address-text'>
                                                                <p className="header-color text-center balance-text">{adminAddr ? adminAddr : ""}</p>
                                                            </div>

                                                            <div className='col-3 address-text' style={{ marginLeft: '10px' }}>
                                                                <p style={{ cursor: 'pointer' }}
                                                                    // onClick={() => handleCopyClick(adminAddr)}
                                                                    className="header-color text-center balance-text">Copy</p>
                                                            </div>
                                                        </div> */}

                  {/* </div> */}
                  {/* </div> */}
                </div>

                {/* <div className='form-header row'>
                                        <p className='col-sm-3 col-form-label text-black'>{symbolVal} Balance</p>
                                        <div className='col-sm-4 address-text' style={{ marginLeft: '10px' }}>
                                            {showCategory && showCategory[0]?.status ? (
                                                <p className="header-color text-center balance-text">{showCategory[0]?.coinBalance}</p>
                                            ) : (
                                                <p className="header-color text-center balance-text"></p>
                                            )}
                                        </div>
                                    </div> */}

                <div class="card-footer">
                  <button
                    type="submit"
                    onClick={rechargeToken}
                    className="changedColor"
                    // onClick={(e) => rechargeToken(e)}
                    // className={loading === true ? "changed" : "changedColor"}
                    style={{ width: "10rem", height: "2rem" }}
                  >
                    Recharge Token
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default TokenRechargePage;
